export enum Views {
    GRID = 'GRID',
    LIST = 'LIST',
}
